// extracted by mini-css-extract-plugin
module.exports = {"pintxo-progress-indicator":"ProgressIndicator_pintxo-progress-indicator__t6S3L","progressIndicator":"ProgressIndicator_progressIndicator__ZMJrn"};